import { useMemo } from 'react';

import { Modal } from '@thefarmersfront/kitchen';

import { Table } from '~/components/common';
import { ModalContentsContainer, ModalLabelValueRow, ModalSection } from '~/components/common/ModalContents';

import {
  getDeliveryAgencyProductNamesColumnDefs,
  getDeliveryAgencyTrackingShippingLabelInfoColumnDefs,
} from '~/utils/delivery-agency/table';

import type { TypeDeliveryAgencyShippingLabelDetail } from '~/types/delivery-agency.types';

const PRODUCT_TABLE_HEIGHT = 244;
/** 헤더와 운송장 한 줄이 들어가는 높이 */
const SHIPPING_LABEL_TABLE_HEIGHT = 100;

const DeliveryAgencyTrackingDetailModal = ({
  open,
  data,
  onClose,
}: {
  open: boolean;
  data: TypeDeliveryAgencyShippingLabelDetail;
  onClose: () => void;
}) => {
  const { columnDefs } = useMemo(() => getDeliveryAgencyTrackingShippingLabelInfoColumnDefs(), []);
  const { columnDefs: productNamesColumnDefs } = useMemo(() => getDeliveryAgencyProductNamesColumnDefs(), []);
  const productNamesData = useMemo(
    () => data.productNames.map((productName) => ({ productName })),
    [data.productNames]
  );
  const shippingLabelInfoData = useMemo(() => [data.shippingLabelInfo], [data.shippingLabelInfo]);

  return (
    <Modal title="운송장 상세" size="xlarge" open={open} onConfirm={onClose}>
      <ModalContentsContainer>
        <ModalSection title="주문 정보">
          <ModalLabelValueRow label="주문자명" value={data.orderInfo.ordererName} />
          <ModalLabelValueRow label="수령자명" value={data.orderInfo.receiverName} />
          <ModalLabelValueRow label="연락처" value={data.orderInfo.receiverContact} />
          <ModalLabelValueRow label="기본주소" value={data.orderInfo.primaryAddress} />
          <ModalLabelValueRow label="상세주소" value={data.orderInfo.secondaryAddress || '-'} />
          <ModalLabelValueRow label="수령장소" value={data.orderInfo.deliveryLocation.description} />
          <ModalLabelValueRow
            label="수령장소 상세"
            value={data.orderInfo.deliveryLocationDetail || '-'}
            preserveWhitespace
          />
          <ModalLabelValueRow label="출입방법" value={data.orderInfo.entranceMethod.description} />
          <ModalLabelValueRow
            label="출입방법 상세"
            value={data.orderInfo.entranceMethodDetail || '-'}
            preserveWhitespace
          />
        </ModalSection>
        <ModalSection title="상품 정보">
          <Table data={productNamesData} columns={productNamesColumnDefs} height={PRODUCT_TABLE_HEIGHT} />
        </ModalSection>
        <ModalSection title="배송 정보">
          <Table data={shippingLabelInfoData} columns={columnDefs} height={SHIPPING_LABEL_TABLE_HEIGHT} />
        </ModalSection>
        {data.shippingLabelInfo.status.code === 'DELIVERY_FAILED' && (
          <ModalSection title="배송 실패">
            <ModalLabelValueRow
              label="배송 실패 사유"
              value={data.shippingLabelInfo.deliveryFailureReasonCategory?.description ?? '-'}
            />
          </ModalSection>
        )}
      </ModalContentsContainer>
    </Modal>
  );
};

export default DeliveryAgencyTrackingDetailModal;
